<template>
  <modal
    width="480px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="$listeners['update:show']">
    <div class="wrap" slot="content">
      <div class="tab">
        <ul class="tab-wrap">
          <li :style="'color: '+$store.state.theme.themeColor"
              @click="(event) => changeTab(event, 'wait')"
              :class="{ active: tab === 'wait' }">个人资料<i :style="'background: '+$store.state.theme.themeColor"></i></li>
          <li @click="(event) => changeTab(event, 'finish')"
              :class="{ active: tab === 'finish' }">修改密码<i></i></li>
        </ul>
      </div>
      <div v-if="tab === 'wait'">
        <div class="info">
          <div class="row" v-show="classUserInfo.account">
            <span class="label">账号</span>：
            <span class="text">{{classUserInfo.account}}</span>
          </div>
          <!-- <div class="row">
            <span class="label">用户名</span>：
            <span class="text">1111</span>
          </div> -->
          <div class="row">
            <span class="label">姓名</span>：
            <span class="text">{{classUserInfo.name}}</span>
          </div>
          <div class="row">
            <span class="label">手机号码</span>：
            <span class="text">{{classUserInfo.mobile}}</span>
          </div>
          <div class="row">
            <span class="label">邮箱</span>：
            <span class="text">{{classUserInfo.email}}</span>
          </div>
          <div class="row">
            <span class="label">单位类型</span>：
            <span class="text">{{classUserInfo.unit_type | formatName}}</span>
          </div>
          <div class="row">
            <span class="label">单位名称</span>：
            <span class="text">{{classUserInfo.school}}</span>
          </div>
          <div class="row">
            <span class="label">所在地区</span>：
            <span class="text">{{classUserInfo.area}}</span>
          </div>
        </div>
        <p class="tip">如果个人资料有误，请联系班级教师或学校管理员进行修改</p>
      </div>
      <div v-if="tab === 'finish'" class="pass-container">
        <div class="pass" :class="{'error-pwd': $v.form.oldPwd.$error}">
          <span class="label">旧密码：</span>
          <el-input type="password" class="search psd-wrap" placeholder="请输入旧密码" v-model="form.oldPwd"></el-input>
          <vd-tips path="form.oldPwd" class="error-tip"/>
        </div>
        <div class="pass" :class="{'error-pwd': $v.form.newPwd.$error}">
          <span class="label">新密码：</span>
          <el-input type="password" class="search psd-wrap" placeholder="请输入新密码" v-model="form.newPwd"></el-input>
          <vd-tips path="form.newPwd" class="error-tip"/>
        </div>
        <div class="pass" :class="{'error-pwd': $v.form.confirmPwd.$error}">
          <span class="label">确认新密码：</span>
          <el-input type="password" class="search psd-wrap" placeholder="请再次输入新密码" v-model="form.confirmPwd"></el-input>
          <vd-tips path="form.confirmPwd" class="error-tip"/>
        </div>
        <div>
          <i class="error-icon"></i>
          <p class="error">为了保证你的帐号安全，密码至少6个字符，建议包含字母和数字。</p>
          <p class="btn"
             :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
             @click="submit">提交</p>
          <p class="psd-tip">修改密码后，需要重新登录帐号</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { required, minLength, sameAs, validationMixin } from '@/utils/mixin_validate'
import Modal from '@/components/Modal'
import { mapState } from 'vuex'
import { Input } from 'element-ui'
export default {
  components: {
    ElInput: Input,
    Modal
  },
  mixins: [validationMixin()],
  validations() {
    return {
      form: {
        oldPwd: {
          required
        },
        newPwd: {
          required,
          minLength: minLength(6)
        },
        confirmPwd: {
          required,
          sameAs: sameAs('newPwd')
        }
      }
    }
  },
  validators: {
    form: {
      oldPwd: {
        required: '旧密码不能为空'
      },
      newPwd: {
        required: '新密码不能为空',
        minLength: '新密码至少6个字符'
      },
      confirmPwd: {
        required: '请再次确认新密码',
        sameAs: '两次输入密码不一致!'
      }
    }
  },
  props: {
    show: Boolean
  },
  computed: {
    ...mapState(['classUserInfo'])
  },
  filters: {
    formatName (value) {
      if (!value || value === 0) {
        return ''
      }
      return value === 1001 ? '学校' : '机构'
    }
  },
  data() {
    return {
      tab: 'wait',
      form: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      }
    }
  },
  methods: {
    changeTab (e, tab) {
      e.target.style = `color: ${this.$store.state.theme.themeColor}`
      e.target.getElementsByTagName('i')[0].style = `background:  ${this.$store.state.theme.themeColor}`
      if (tab === 'wait') {
        e.target.parentNode.getElementsByTagName('li')[1].style = ''
      } else {
        e.target.parentNode.getElementsByTagName('li')[0].style = ''
      }
      this.tab = tab
    },
    async submit () {
      const { oldPwd, newPwd, confirmPwd } = this.form
      await this.validationTouch()
      await this.$auth('change_pwd_by_old', ...[oldPwd, newPwd, confirmPwd])
      this.$message.success('修改密码成功，请重新登录账号')
      setTimeout(async () => {
        await this.$store.dispatch('logout')
        if (window.location.href.indexOf(CONFIG.noc2024) === -1) {
          this.$router.push({ name: 'login' })
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  height: 70px;
  align-items: center;
  // justify-content: space-between;
  border-bottom: 1px solid #F2F7FF;
  .tab-wrap {
    li {
      cursor: pointer;
      float: left;
      position: relative;
      font-size: 20px;
      color: #666;
      margin-right: 40px;
      line-height: 71px;
       i {
          position: absolute;
          bottom: 0;
          opacity: 0;
          left: 24px;
          width: 32px;
          height: 2px;
          background: $themeColor;
       }
    }
    .active {
      color: $themeColor;
      i {
        opacity: 1;
        transition: .5s;
      }
    }
  }
}
.info {
  margin: 26px 0 0 35px;
}
.row {
  display: flex;
  color: #333;
  margin-bottom: 25px;
  .label {
    display: inline-block;
    width: 70px;
    line-height: 22px;
    font-weight: 500;
    color: #333;
    font-size: 16px;
    text-align-last: justify;
  }
  .text {
    font-size: 16px;
    line-height: 22px;
    color: #666;
    margin-left: 15px;
    font-weight: 400;
  }
}
.tip {
  color: #666;
  font-size: 12px;
  margin: 0 0 15px 35px;
  &::before {
    content: '';
    width: 14px;
    height: 14px;
    display: inline-block;
    background: url('~@/assets/images/tip.png') no-repeat center / cover;
    vertical-align: -1px;
    margin-right: 10px;
  }
}
.pass-container {
  padding-top: 50px;
  .error-icon {
    float: left;
    width: 14px;
    height: 14px;
    margin: 9px 10px 0 112px;
    background: url('~@/assets/images/warning@2x.png') no-repeat center / cover;
  }
  .error {
    padding-top: 8px;
    overflow: hidden;
    width: 232px;
    color: #F5222D;
    font-size: 12px;
    font-weight: 300;
  }
}
.pass {
  display: flex;
  position: relative;
  align-items: center;
  margin-bottom: 15px;
  .label {
    width: 112px;
    font-weight: 500;
    font-size: 14px;
    text-align: right;
  }
  .psd-wrap {
    width: 300px;
  }
  .error-tip {
    position: absolute;
    display: none;
    color: #F5222D;
    font-size: 12px;
    left: 112px;
    top: 30px;
  }
}
.error-pwd .error-tip {
  display: block;
}
.btn {
  cursor: pointer;
  width: 140px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  font-weight: 300;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  box-shadow: $buttonShadow;
  background: $buttonBackground;
  margin: 100px auto 12px;
}
.psd-tip {
  text-align: center;
  font-size: 12px;
  color: #999;
  font-weight: 300;
  margin-bottom: 15px;
}
</style>
